<script setup>
defineProps({
    item: Object,
});
</script>

<template>
    <div class="flex flex-col gap-2">
        <img
            v-if="item.icon"
            :src="item.icon"
            :alt="item.icon_alt"
            :title="item.icon_title"

            :class="'w-10 mb-2 md:mb-4 md:max-w-20'"
        >

        <div class="flex flex-col">
            <h3 v-if="item.title">
                {{ item.title }}
            </h3>
            <div
                v-if="item.text"
                class="prose"
                v-html="item.text"
            />
        </div>
    </div>
</template>
